import { render, staticRenderFns } from "./DPEnviromentTable.vue?vue&type=template&id=1a1a392c&scoped=true&"
import script from "./DPEnviromentTable.vue?vue&type=script&lang=js&"
export * from "./DPEnviromentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1a392c",
  null
  
)

export default component.exports